const ROUTES_DOCUMENT_WIZARD = {
    BASE: {
        name: 'doc-wizard'
    },
    WIZARD: {
        name: 'doc-wizard.wizard'
    },
    SETUP_DOCUMENT: {
        name: 'doc-wizard.setup-document'
    },
    CREATE_TEMPLATE: {
        name: 'doc-wizard.create-template'
    }
}

const NEED_HELP_URL =
    'https://help.advisera.com/categories/conformio-grc-software/'

const DOCUMENT_STATUSES = {
    IN_PROGRESS: 'in_progress',
    IN_REVIEW: 'in_review',
    IN_APPROVAL: 'in_approval',
    COMPLETED: 'completed',
    CORRECTIONS_NEEDED: 'corrections_needed',
    WITHDRAWN: 'withdrawn'
}

const APPROVERS_NAME = 'approvers'
const REVIEWERS_NAME = 'reviewers'
const READERS_NAME = 'readers'
const OWNER_NAME = 'owner'
const INTERVAL_NAME = 'update_interval'

const PROPERTIES_SORT = {
    [OWNER_NAME]: 1,
    [INTERVAL_NAME]: 2,
    [REVIEWERS_NAME]: 3,
    [APPROVERS_NAME]: 4,
    [READERS_NAME]: 5
}

const DOCUMENT_STATUSES_MAPPED = {
    [DOCUMENT_STATUSES.IN_PROGRESS]: {
        backgroundColorClass: 'background-primary-epsilon',
        label: 'REGULATION.IN_PROGRESS',
        icon: 'icon-refresh-circle',
        isOptional: false,
        showInTimeline: true
    },
    [DOCUMENT_STATUSES.IN_REVIEW]: {
        backgroundColorClass: 'background-warning-alpha',
        label: 'REGULATION.IN_REVIEW',
        icon: 'icon-point-circle',
        isOptional: true,
        showInTimeline: true
    },
    [DOCUMENT_STATUSES.IN_APPROVAL]: {
        backgroundColorClass: 'background-warning-gamma',
        label: 'REGULATION.IN_APPROVAL',
        icon: 'icon-approve-circle',
        isOptional: false,
        showInTimeline: true
    },
    [DOCUMENT_STATUSES.CORRECTIONS_NEEDED]: {
        backgroundColorClass: 'background-danger-alpha',
        label: 'REGULATION.CORRECTIONS_NEEDED',
        icon: 'icon-exclamation-circle',
        isOptional: true,
        showInTimeline: true
    },
    [DOCUMENT_STATUSES.COMPLETED]: {
        backgroundColorClass: 'background-success-alpha',
        label: 'REGULATION.APPROVED',
        icon: 'icon-check-circle',
        isOptional: false,
        showInTimeline: true
    },
    [DOCUMENT_STATUSES.WITHDRAWN]: {
        backgroundColorClass: 'background-gray-beta',
        label: 'REGULATION.WITHDRAWN',
        icon: 'icon-arrow-down-circle',
        isOptional: false,
        showInTimeline: false
    }
}

const DOWNLOAD_TYPES = {
    PDF: 'pdf',
    DOCX: 'docx'
}

const DOCUMENT_CONTENT_TYPES = {
    HTML: 'html',
    PDF: 'pdf'
}

const DW_FORMAT = {
    DOCX: 'docx',
    HTML: 'html'
}

const DOCUMENTABLE_TYPES = {
    CONFORMIO_DOCUMENT: 'conformio-document',
    USER_UPLOADED_DOCUMENT: 'user-uploaded-document',
    HTML_DOCUMENT: 'html-document'
}

const USER_UPLOADED_DOCUMENT_TYPES = {
    PDF: ['application/pdf'],
    WORD: [
        'application/msword',
        'application/x-msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
}

const DOCUMENT_WIZARD_MODES = {
    CREATE: 'create',
    RESTART: 'restart',
    EDIT: 'edit'
}

export {
    ROUTES_DOCUMENT_WIZARD,
    NEED_HELP_URL,
    DOCUMENT_STATUSES,
    DOCUMENT_STATUSES_MAPPED,
    APPROVERS_NAME,
    REVIEWERS_NAME,
    READERS_NAME,
    OWNER_NAME,
    INTERVAL_NAME,
    PROPERTIES_SORT,
    DOWNLOAD_TYPES,
    DOCUMENTABLE_TYPES,
    USER_UPLOADED_DOCUMENT_TYPES,
    DW_FORMAT,
    DOCUMENT_WIZARD_MODES,
    DOCUMENT_CONTENT_TYPES
}
